/** @griffel:css-start [d] null **/
.fly5x3f{width:100%;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f9b8bpc{padding-block:var(--spacingVerticalS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkfq4zb{color:var(--colorNeutralForeground2);}
.f1k6fduh{cursor:pointer;}
.fl43uef{font-weight:var(--fontWeightSemibold);}
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f778t4r{row-gap:var(--spacingVerticalXS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f183lrzt{margin-block:var(--spacingVerticalS);}
.f9b8bpc{padding-block:var(--spacingVerticalS);}
.f12n3xlw{padding-inline:var(--spacingHorizontalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f16xq7d1{background-color:var(--colorNeutralBackground3);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fjksvth{overflow-wrap:anywhere;}
/** @griffel:css-end **/